import { Grid } from "@mui/material";

import { wallets, BUYER } from "../constants";

import "../styles.css";

export const options: any = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

const CustomerPay = (props: any) => {
  const { type, transactionsInfo } = props;

  return (
    <>
      <Grid
        item
        md={2}
        sx={{ display: { xs: "none", sm: "block" } }}
        className="trans-center">
        <span className="trans-amount-green">
          +{transactionsInfo.amount + " " + wallets.SAR}
        </span>
      </Grid>
      <Grid item md={6} xl={6} sx={{ display: { xs: "block", sm: "block" } }}>
        <div className="trans-title">
          {type === BUYER
            ? wallets.PAYMENT_CUSTOMER_PAY_BUYER
            : wallets.PAYMENT_SELLER_CUSTOMER_PAY_BUYER}

          <span className="trans-title-name">
            {transactionsInfo.beneficiaryName}
          </span>
        </div>
        <div className="trans-sub">
          {type === BUYER
            ? wallets.PAYMENT_CUSTOMER_PAY_BUYER_SUB
            : wallets.PAYMENT_CUSTOMER_PAY_BUYER_SUB}
        </div>
      </Grid>
    </>
  );
};
export default CustomerPay;
